/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ProcessedSubscriptionPostSpec { 
    charge_id: string;
    created_ts: Date;
    datacenter: string;
    from_ts: Date;
    org_id: string;
    quantity: number;
    to_ts: Date;
    updated_ts?: Date;
}

